<h2 mat-dialog-title class="auditTrain-heading"><a style="color: gray; font-size: 22px;font-family: sans-serif;"><b>Return Reason</b></a>
</h2>
<div class="row" *ngIf="ErrorMessage.length > 0">
        <div class="col-md-12">
          <div style="font-size:small;">
            <img src="assets/img/error_icon.gif" /><span class="text-error" style="font-weight:bold;color:red;">
              The
              following errors were encountered on the page.
            </span>
          </div>
          <div id="divMainError" class="text-error"
            style="padding-top:0px; margin-bottom:10px;margin-left:25px; font-size:small; color:red">
            <span style="display:list-item" *ngFor="let item of ErrorMessage">{{item.message}}</span>
          </div>
        </div>
      </div>
<div class="row">
    <div class="form-horizontal" style="padding: 15px;padding-left: 30px;">
        <div class="row" style="padding-top:7px;">
            <div class="col-md-12">
                <div class="row form-group">
                    <span class="col-sm-4" style="padding-top: 7px;">Return Comments<span style="color: red;">*:</span></span>
                    <div class="col-md-8 col-sm-8">
                    <div style="padding-right: 10px;">
                        <input type="text" id="txtRollBackStatusReason" maxlength="100" name="txtRollBackStatusReason" class="form-control"
                        [(ngModel)]="ReturnReason" autocomplete="off">
                    </div>
                  </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="modal-footer">
        <button type="button" class="btn btn-primary auditTrain-btn"
        (click)="UpdateStatusChange()">OK</button>
    <button type="button" class="btn btn-primary auditTrain-btn"
        (click)="closeDialog()">Close</button>
</div>
<br>
